import { useContext } from 'react';

import SnackbarContext, { SnackbarContext as ISnackbarContext } from './Snackbar.context';

export const useSnackbar = () => useContext(SnackbarContext) as ISnackbarContext;
